import React, { useState, useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import Select from "react-select";
import OverlayLoader from "../Components/OverlayLoader";
import { MultiValue } from "react-select";
import {
  fetchStateData,
  fetchDistrictData,
  fetchCityData,
  fetchMeadiaSourceData,
  fetchAllSubMediaSource,
  fetchUserData,
  User,
  fetchProjectData,
  GetAllFollowUpTypes,
  createUserTask,
  getAllPreferenceTypes,
  PreferenceItem,
  savePreference,
  FetchedPreferenceItem,
  createLead,
  fetchLocationData,
  GetPropertyTypes,
  GetCountryCodes,
  CountryCodeDto
} from "../Services/APIService";
// import { on } from "events";

// Existing interfaces
interface State {
  stateId: number;
  stateName: string;
  isActive: boolean;
}

interface District {
  districtId: number;
  districtName: string;
  stateId: number;
  stateName: string;
  isActive: boolean;
}

interface City {
  cityId: number;
  cityName: string;
  districtId: number;
  districtName: string;
  stateId: number;
  stateName: string;
  isActive: boolean;
}

interface MediaSource {
  sourceId: number;
  sourceName: string;
  isActive: boolean;
}

interface MediaSourceOption {
  value: number;
  label: string;
}

interface StateOption {
  value: number;
  label: string;
}

interface DistrictOption {
  value: number;
  label: string;
}

interface CityOption {
  value: number;
  label: string;
}

interface UserOption {
  value: number;
  label: string;
}

interface SubMediaSource {
  mediaSourceID: number;
  name: string;
  id: number;
  isActive: boolean;
}

// New interfaces for additional tabs
interface Project {
  projectID: number;
  projectName: string;
  isActive: boolean;
}

interface ProjectOption {
  value: number;
  label: string;
}

interface FollowupType {
  id: number;
  name: string;
  isActive: boolean;
}

interface FollowupTypeOption {
  value: number;
  label: string;
}

interface PreferenceRow {
  id: number;
  typeId: number;
  typeLabel: string;
  valueId: number;
  valueLabel: string;
  specialNote: string;
}

// Enhanced FormData interface
interface FormData {
  firstName: string;
  lastName: string;
  gender: string;
  dob?: string;
  dom?: string;
  mobile: string;
  email: string;
  address: string;
  stateId: number;
  districtId: number;
  cityId: number;
  zipCode: number;
  sourceId: number;
  subSourceId: number;
  currentStatus: number;
  incomeFrom: number;
  incomeTo: number;
  budgetMin: number;
  budgetMax: number;
  possession: string;
  initialAssignedUser: number;
  currentAssignedUser: number;
  tenantId: number;
  createdBy: number;
  assignType: string;
  siteVisitRemarks?: string;
  siteVisitProject?: number;
  siteVisitDateTime?: string;
  scheduleFollowup: boolean;
  followupDate?: string;
  followupRemarks?: string;
  followupType?: number;
  followupProject?: number;

  // ── FIXED: string to match COUNTRY_CODES value format "+91" ──
  countryCode: string;
  alternateMobile: string;
  alternateMobileCountryCode: string;
}

interface ValidationErrors {
  firstName?: string;
  lastName?: string;
  gender?: string;
  dob?: string;
  dom?: string;
  mobile?: string;
  email?: string;
  address?: string;
  stateId?: string;
  districtId?: string;
  cityId?: string;
  zipCode?: string;
  sourceId?: string;
  subSourceId?: string;
  incomeFrom?: string;
  incomeTo?: string;
  budgetMin?: string;
  budgetMax?: string;
  possession?: string;
  assignType?: string;
  initialAssignedUser?: string;
  siteVisitDateTime?: string;
  followupDate?: string;
  followupType?: string;
  followupProject?: string;
  countryCode?: string;
  alternateMobile?: string;
}

interface AddLeadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

interface OptionType {
  value: number;
  label: string;
}

interface PreferenceOption {
  id: number;
  label: string;
}

const AddLeadModal: React.FC<AddLeadModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  // Existing state
  const [states, setStates] = useState<State[]>([]);
  const [stateOptions, setStateOptions] = useState<StateOption[]>([]);
  const [allDistricts, setAllDistricts] = useState<District[]>([]);
  const [districtOptions, setDistrictOptions] = useState<DistrictOption[]>([]);
  const [filteredDistricts, setFilteredDistricts] = useState<District[]>([]);
  const [allCities, setAllCities] = useState<City[]>([]);
  const [cityOptions, setCityOptions] = useState<CityOption[]>([]);
  const [filteredCities, setFilteredCities] = useState<City[]>([]);
  const [mediaSource, setMediaSource] = useState<MediaSource[]>([]);
  const [countryCodes, setCountryCodes] = useState<CountryCodeDto[]>([]);
  const [mediaSourceOptions, setmediaSourceOptions] = useState<
    MediaSourceOption[]
  >([]);
  const [subMediaSource, setSubMediaSource] = useState<SubMediaSource[]>([]);
  const [filteredSubMediaSource, setFilteredSubMediaSource] = useState<
    SubMediaSource[]
  >([]);
  const [assignedUser, setAssignedUser] = useState<User[]>([]);
  const [userOptions, setUserOptions] = useState<UserOption[]>([]);
  const [selectedAssignUserId, setSelectedAssignUserId] = useState<
    number | null
  >(null);

  // New state for additional tabs
  const [projects, setProjects] = useState<Project[]>([]);
  const [projectOptions, setProjectOptions] = useState<ProjectOption[]>([]);
  const [followupTypes, setFollowupTypes] = useState<FollowupType[]>([]);
  const [followupTypeOptions, setFollowupTypeOptions] = useState<
    FollowupTypeOption[]
  >([]);

  // Preference state
  const [preferences, setPreferences] = useState<PreferenceItem[]>([]);
  const [selectedPreferenceId, setSelectedPreferenceId] = useState<
    number | null
  >(null);
  const [secondaryOptions, setSecondaryOptions] = useState<
    { id: number; label: string }[]
  >([]);
  const [selectedSecondary, setSelectedSecondary] = useState<
    { id: number; label: string }[]
  >([]);
  const [addedPreferences, setAddedPreferences] = useState<PreferenceRow[]>([]);
  const [idCounter, setIdCounter] = useState(1);
  const [preferenceOptions, setPreferenceOptions] = useState<{
    [key: number]: { id: number; label: string }[];
  }>({});
  const [selectedPreferences, setSelectedPreferences] = useState<{
    [key: number]: number[];
  }>({});

  // Loading states
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<ValidationErrors>({});
  const [isLoadingStates, setIsLoadingStates] = useState(false);
  const [isLoadingDistricts, setIsLoadingDistricts] = useState(false);
  const [isLoadingCities, setIsLoadingCities] = useState(false);
  const [isLoadingSourceMedia, setIsLoadingSourceMedia] = useState(false);
  const [isLoadingSubSourceMedia, setIsLoadingSubSourceMedia] = useState(false);
  const [isLoadingProjects, setIsLoadingProjects] = useState(false);
  const [isLoadingFollowupTypes, setIsLoadingFollowupTypes] = useState(false);
  const [isLoadingPreferences, setIsLoadingPreferences] = useState(false);

  const [activeTab, setActiveTab] = useState("leadDetails");
  const [areaPreferenceText, setAreaPreferenceText] = useState<string>("");

  const [formData, setFormData] = useState<FormData>({
    firstName: "",
    lastName: "",
    gender: "",
    dob: "",
    dom: "",
    mobile: "",
    email: "",
    address: "",
    stateId: 0,
    districtId: 0,
    cityId: 0,
    zipCode: 0,
    sourceId: 0,
    subSourceId: 0,
    currentStatus: 0,
    incomeFrom: 0,
    incomeTo: 0,
    budgetMin: 0,
    budgetMax: 0,
    possession: "",
    initialAssignedUser: 0,
    currentAssignedUser: 0,
    tenantId: 0,
    createdBy: 0,
    assignType: "self",
    scheduleFollowup: false,
    countryCode: "+91",                 // ✅ string
    alternateMobile: "",
    alternateMobileCountryCode: "+91",  // ✅ string
  });
  const requiredField = <span className="text-danger ms-1">*</span>;

  // Initialize data on component mount
  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingStates(true);
      setIsLoadingDistricts(true);
      setIsLoadingCities(true);
      setIsLoadingSourceMedia(true);
      setIsLoadingSubSourceMedia(true);
      setIsLoadingProjects(true);
      setIsLoadingFollowupTypes(true);
      setIsLoadingPreferences(true);

      try {
        // Existing API calls
        const stateAllData = await fetchStateData();
        const stateData = stateAllData.filter((state) => state.isActive);
        setStates(stateData);
        const stateOptions = stateData.map((state) => ({
          value: state.stateId,
          label: state.stateName,
        }));
        setStateOptions(stateOptions);

        const districtAllData = await fetchDistrictData();
        const districtData = districtAllData.filter(
          (district) => district.isActive
        );
        setAllDistricts(districtData);

        const cityAllData = await fetchCityData();
        const cityData = cityAllData.filter((city) => city.isActive);
        setAllCities(cityData);

        const mediaSourceAllData = await fetchMeadiaSourceData();
        const mediaSource = mediaSourceAllData.filter(
          (source) => source.isActive
        );
        setMediaSource(mediaSource);
        const option = mediaSource.map((source) => ({
          value: source.sourceId,
          label: source.sourceName,
        }));
        setmediaSourceOptions(option);

        const subMediaAllData = await fetchAllSubMediaSource();
        const subMediaSourceList = subMediaAllData.filter(
          (subSource) => subSource.isActive
        );
        setSubMediaSource(subMediaSourceList);

        const assignUserList = await fetchUserData();
        const activeUsers = assignUserList.filter(
          (user) =>
            (user.userTypeId === 2 || user.userTypeId === 4) && user.isActive
        ); // Exclude userTypeId 3
        setAssignedUser(activeUsers);
        const userOptions = assignUserList.map((user) => ({
          value: user.userId,
          label: user.userName,
        }));
        setUserOptions(userOptions);

        // New API calls for additional tabs
        const projectAllData = await fetchProjectData();
        const projectData = projectAllData.filter(
          (project) => project.isActive
        );
        setProjects(projectData);
        const projectOptions = projectData.map((project) => ({
          value: project.projectID,
          label: project.projectName,
        }));
        setProjectOptions(projectOptions);

        const followupAllData = await GetAllFollowUpTypes();
        const followupData = followupAllData.filter((type) => type.isActive);
        setFollowupTypes(followupData);
        const followupOptions = followupData
          .filter((type) => type.id !== 0 && type.id !== 1) // Filter out IDs 0 and 1
          .map((type) => ({
            value: type.id,
            label: type.name,
          }));
        setFollowupTypeOptions(followupOptions);

        const prefList = await getAllPreferenceTypes();
        setPreferences(prefList);

        // ✅ Fetch country codes from API
        const ccData = await GetCountryCodes();
        setCountryCodes(ccData);

        // ✅ Set India as default if found
        const india = ccData.find((c) => c.value === "+91");
        if (india) {
          setFormData((prev) => ({
            ...prev,
            countryCode: india.value,
            alternateMobileCountryCode: india.value,
          }));
        }
      } catch (error) {
        console.error(error);
        toast.error("Failed to load required data");
      } finally {
        setIsLoadingStates(false);
        setIsLoadingDistricts(false);
        setIsLoadingCities(false);
        setIsLoadingSourceMedia(false);
        setIsLoadingSubSourceMedia(false);
        setIsLoadingProjects(false);
        setIsLoadingFollowupTypes(false);
        setIsLoadingPreferences(false);
      }
    };

    fetchData();
  }, []);

  // Existing useEffects for dependent dropdowns
  useEffect(() => {
    if (formData.stateId && allDistricts.length > 0) {
      const districts = allDistricts.filter(
        (district) => district.stateId === formData.stateId && district.isActive
      );
      setFilteredDistricts(districts);
      const districtOptions = districts.map((district) => ({
        value: district.districtId,
        label: district.districtName,
      }));
      setDistrictOptions(districtOptions);
      if (
        formData.districtId &&
        !districts.some((d) => d.districtId === formData.districtId)
      ) {
        setFormData((prev) => ({ ...prev, districtId: 0, cityId: 0 }));
      }
    } else {
      setFilteredDistricts([]);
      setFormData((prev) => ({ ...prev, districtId: 0, cityId: 0 }));
    }
  }, [formData.stateId, allDistricts]);

  useEffect(() => {
    if (formData.districtId && allCities.length > 0) {
      const cities = allCities.filter(
        (city) => city.districtId === formData.districtId
      );
      setFilteredCities(cities);
      const cityOptions = cities.map((city) => ({
        value: city.cityId,
        label: city.cityName,
      }));
      setCityOptions(cityOptions);
      if (
        formData.cityId &&
        !cities.some((c) => c.cityId === formData.cityId)
      ) {
        setFormData((prev) => ({ ...prev, cityId: 0 }));
      }
    } else {
      setFilteredCities([]);
      setFormData((prev) => ({ ...prev, cityId: 0 }));
    }
  }, [formData.districtId, allCities]);

  useEffect(() => {
    if (formData.sourceId && subMediaSource.length > 0) {
      const source = subMediaSource.filter(
        (src) => src.mediaSourceID === formData.sourceId
      );
      setFilteredSubMediaSource(source);
      if (!source.some((s) => s.mediaSourceID === formData.sourceId)) {
        setFormData((prev) => ({ ...prev, subSourceId: 0 }));
      }
    } else {
      setFilteredSubMediaSource([]);
      setFormData((prev) => ({ ...prev, subSourceId: 0 }));
    }
  }, [formData.sourceId, subMediaSource]);

  // New useEffect for preference secondary options
  useEffect(() => {
    const fetchData = async () => {
      if (!selectedPreferenceId) return;

      try {
        let options: { id: number; label: string }[] = [];
        const tenantId = localStorage.getItem("tenantId");

        if (selectedPreferenceId === 1) {
          const locations = await fetchLocationData();
          options = locations.map((item: any) => ({
            id: item.locationID,
            label: item.locationName,
          }));
        } else if (selectedPreferenceId === 2) {
          const projects = await fetchProjectData();
          options = projects.map((item: any) => ({
            id: item.projectID,
            label: item.projectName,
          }));
        } else if (selectedPreferenceId === 4) {
          const payload = { tenantId: parseInt(tenantId || "0") };
          const propertyTypes = await GetPropertyTypes(payload);
          options = propertyTypes.data.propertyTypes.map((item: any) => ({
            id: item.typeId,
            label: item.typeName,
          }));
        } else {
          const selectedPref = preferences.find(
            (p) => p.id === selectedPreferenceId
          );
          if (selectedPref?.preferenceDataJson) {
            const parsed = JSON.parse(selectedPref.preferenceDataJson);
            options = parsed.map((item: any) => ({
              id: item.name,
              label: item.name,
            }));
          }
        }

        setSecondaryOptions(options);
      } catch (error) {
        console.error("Failed to fetch secondary options:", error);
        toast.error("Failed to load preference values");
        setSecondaryOptions([]);
      }
    };

    fetchData();
  }, [selectedPreferenceId, preferences]);

  useEffect(() => {
    const fetchAllPreferenceOptions = async () => {
      if (preferences.length === 0) return;

      const optionsMap: { [key: number]: { id: number; label: string }[] } = {};

      for (const preference of preferences) {
        try {
          let options: { id: number; label: string }[] = [];
          const tenantId = localStorage.getItem("tenantId");

          if (preference.id === 1) {
            const locations = await fetchLocationData();
            options = locations.map((item: any) => ({
              id: item.locationID,
              label: item.locationName,
            }));
          } else if (preference.id === 2) {
            const projects = await fetchProjectData();
            options = projects.map((item: any) => ({
              id: item.projectID,
              label: item.projectName,
            }));
          } else if (preference.id === 4) {
            const payload = { tenantId: parseInt(tenantId || "0") };
            const propertyTypes = await GetPropertyTypes(payload);
            options = propertyTypes.data.propertyTypes.map((item: any) => ({
              id: item.typeId,
              label: item.typeName,
            }));
          } else {
            if (preference.preferenceDataJson) {
              const parsed = JSON.parse(preference.preferenceDataJson);
              options = parsed.map((item: any) => ({
                id: item.name,
                label: item.name,
              }));
            }
          }

          if (options.length > 0) {
            optionsMap[preference.id] = options;
          }
        } catch (error) {
          console.error(
            `Failed to fetch options for preference ${preference.id}:`,
            error
          );
        }
      }

      setPreferenceOptions(optionsMap);
    };

    fetchAllPreferenceOptions();
  }, [preferences]);

  const handlePreferenceChange = (
    preferenceTypeId: number,
    selectedValue: number
  ) => {
    setSelectedPreferences((prev) => ({
      ...prev,
      [preferenceTypeId]: selectedValue === 0 ? [] : [selectedValue],
    }));
  };

  // Validation functions
  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateMobile = (mobile: string): boolean => {
    const mobileRegex = /^\d+$/;
    return mobileRegex.test(mobile);
  };

  const validateLeadDetailsTab = (): boolean => {
    const newErrors: ValidationErrors = {};
    let isValid = true;

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
      isValid = false;
    }
    // if (!formData.lastName.trim()) {
    //   newErrors.lastName = "Last name is required";
    //   isValid = false;
    // }
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
      isValid = false;
    } else if (!validateMobile(formData.mobile)) {
      newErrors.mobile = "Mobile number should contain only digits";
      isValid = false;
    }
    // if (!formData.email.trim()) {
    //   newErrors.email = "Email is required";
    //   isValid = false;
    // } else if (!validateEmail(formData.email)) {
    //   newErrors.email = "Invalid email format";
    //   isValid = false;
    // }
    if (!formData.sourceId) {
      newErrors.sourceId = "Please select a Source";
      isValid = false;
    }
    // if (!formData.subSourceId) {
    //   newErrors.subSourceId = "Please select a Subsource";
    //   isValid = false;
    // }
    if (!formData.assignType) {
      newErrors.assignType = "Please select an Assign Type";
      isValid = false;
    }
    if (formData.assignType === "assign" && !formData.initialAssignedUser) {
      newErrors.initialAssignedUser = "Please select a user to assign";
      isValid = false;
    }
    // ── NEW: Alternate mobile validation (optional but must be digits if filled)
    if (
      formData.alternateMobile.trim() &&
      !validateMobile(formData.alternateMobile)
    ) {
      newErrors.alternateMobile = "Alternate mobile should contain only digits";
      isValid = false;
    }
    setError(newErrors);
    return isValid;
  };

  const validateFollowupTab = (): boolean => {
    const newErrors: ValidationErrors = {};
    let isValid = true;

    // Site visit validations
    if (formData.siteVisitProject && !formData.siteVisitDateTime) {
      newErrors.siteVisitDateTime =
        "Site visit date time is required when project is selected";
      isValid = false;
    }

    // Follow-up validations
    if (formData.scheduleFollowup) {
      if (!formData.followupDate) {
        newErrors.followupDate = "Follow-up date is required";
        isValid = false;
      }
      if (!formData.followupType) {
        newErrors.followupType = "Follow-up type is required";
        isValid = false;
      }
      // If Site Visit is selected as follow-up type, project is mandatory
      const siteVisitType = followupTypes.find((type) =>
        type.name.toLowerCase().includes("site visit")
      );
      if (
        formData.followupType === siteVisitType?.id &&
        !formData.followupProject
      ) {
        newErrors.followupProject =
          "Project is required for site visit follow-up";
        isValid = false;
      }
    }

    setError(newErrors);
    return isValid;
  };

  const validateForm = (): boolean => {
    return (
      validateLeadDetailsTab() &&
      //validateOtherDetailsTab() &&
      validateFollowupTab()
    );
  };

  // Handle input changes
  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value, type } = e.target;

    let parsedValue: any = value;

    if (type === "checkbox") {
      parsedValue = (e.target as HTMLInputElement).checked;
    } else if (
      [
        "zipCode",
        "incomeFrom",
        "incomeTo",
        "budgetMin",
        "budgetMax",
        "initialAssignedUser",
        "siteVisitProject",
        "followupType",
        "followupProject",
      ].includes(name)
    ) {
      if (value === "" || /^[0-9]*$/.test(value)) {
        parsedValue = value === "" ? 0 : parseInt(value, 10);
      } else {
        return; // Block invalid input
      }
    }

    // Handle assignType separately
    if (name === "assignType") {
      const userId = parseInt(localStorage.getItem("UserId") ?? "0");
      setFormData((prev) => ({
        ...prev,
        assignType: value,
        initialAssignedUser:
          value === "self" ? userId : prev.initialAssignedUser,
        currentAssignedUser:
          value === "self" ? userId : prev.currentAssignedUser,
      }));
      setSelectedAssignUserId(value === "self" ? userId : null);
    } else if (name === "initialAssignedUser") {
      const userId = parseInt(value);
      setSelectedAssignUserId(userId);
      setFormData((prev) => ({
        ...prev,
        initialAssignedUser: userId,
        currentAssignedUser: userId,
      }));
    } else if (name === "mobile") {
      if (value !== "" && !/^[0-9]*$/.test(value)) {
        return;
      }
      setFormData((prev) => ({ ...prev, mobile: value }));
    } else if (name === "stateId") {
      setFormData((prev) => ({
        ...prev,
        stateId: parseInt(value),
        districtId: 0,
        cityId: 0,
      }));
    } else if (
      ["districtId", "cityId", "sourceId", "subSourceId"].includes(name)
    ) {
      setFormData((prev) => ({
        ...prev,
        [name]: parseInt(value),
        ...(name === "sourceId" && { subSourceId: 0 }),
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: parsedValue }));
    }

    // Clear error
    setError((prev) => ({ ...prev, [name]: undefined }));
  };

  // Preference handling functions
  const validatePreferenceForm = () => {
    const errors: { type?: string; value?: string } = {};
    if (!selectedPreferenceId) errors.type = "Please select a preference type.";
    if (selectedPreferenceId && selectedSecondary.length === 0) {
      errors.value = "Please select at least one preference value.";
    }
    return errors;
  };

  const handleAddPreference = () => {
    const errors = validatePreferenceForm();
    if (Object.keys(errors).length > 0) {
      toast.error("Please fill all required preference fields");
      return;
    }

    const selectedType = preferences.find((p) => p.id === selectedPreferenceId);
    if (!selectedType) return;

    const newItems: PreferenceRow[] = selectedSecondary
      .filter(
        (val) =>
          !addedPreferences.some(
            (p) => p.typeId === selectedType.id && p.valueId === val.id
          )
      )
      .map((val) => ({
        id: idCounter + Math.random(),
        typeId: selectedType.id,
        typeLabel: selectedType.preferenceName,
        valueId: val.id,
        valueLabel: val.label,
        specialNote: "",
      }));

    if (newItems.length === 0) {
      toast.error("These preferences are already added.");
      return;
    }

    setAddedPreferences((prev) => [...prev, ...newItems]);
    setIdCounter((prev) => prev + newItems.length);
    setSelectedSecondary([]);
  };

  const handleNoteChange = (id: number, note: string) => {
    setAddedPreferences((prev) =>
      prev.map((p) => (p.id === id ? { ...p, specialNote: note } : p))
    );
  };

  const handleDeletePreference = (id: number) => {
    setAddedPreferences((prev) => prev.filter((p) => p.id !== id));
  };

  // Handle Select changes
  const handleSelectChange = (name: string, selectedOption: any) => {
    const value = selectedOption ? selectedOption.value : 0;

    if (name === "sourceId") {
      setFormData((prev) => ({ ...prev, sourceId: value, subSourceId: 0 }));
    } else if (["stateId", "districtId", "cityId"].includes(name)) {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        ...(name === "stateId" && { districtId: 0, cityId: 0 }),
        ...(name === "districtId" && { cityId: 0 }),
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    setError((prev) => ({ ...prev, [name]: undefined }));
  };

  const handleMultiSelectChange = (
    selected: { id: number; label: string }[]
  ) => {
    setSelectedSecondary(selected || []);
  };

  // Tab navigation
  const handleTabClick = (tabId: string) => {
    if (tabId === "preferences" && !validateLeadDetailsTab()) {
      toast.error("Please complete Lead Details first");
      return;
    }
    if (tabId === "otherDetails" && !validateLeadDetailsTab()) {
      toast.error("Please complete Lead Details first");
      return;
    }
    if (tabId === "followup" && !validateLeadDetailsTab()) {
      toast.error("Please complete Lead Details first");
      return;
    }
    setActiveTab(tabId);
  };

  const handleDateTimeChange = (e: any) => {
    const selectedDateTime = new Date(e.target.value);
    const currentDateTime = new Date();

    if (selectedDateTime < currentDateTime) {
      // Show error or reset to current time
      toast.error("Please select a future date and time");
      return;
    }

    handleInputChange(e);
  };

  const handleNext = (currentTab: string) => {
    switch (currentTab) {
      case "leadDetails":
        if (validateLeadDetailsTab()) {
          setActiveTab("preferences");
        }
        break;
      case "preferences": {
        // Collect preferences when moving from preferences tab
        const collectedPreferences: PreferenceRow[] = [];
        let preferenceIdCounter = 1;

        Object.entries(selectedPreferences).forEach(([typeId, valueIds]) => {
          if (valueIds && valueIds.length > 0) {
            const preferenceType = preferences.find(
              (p) => p.id === parseInt(typeId)
            );

            valueIds.forEach((valueId) => {
              const preferenceValue = preferenceOptions[parseInt(typeId)]?.find(
                (option) => option.id === valueId
              );

              if (preferenceType && preferenceValue) {
                collectedPreferences.push({
                  id: preferenceIdCounter++,
                  typeId: parseInt(typeId),
                  typeLabel: preferenceType.preferenceName,
                  valueId: valueId,
                  valueLabel: preferenceValue.label,
                  specialNote: "",
                });
              }
            });
          }
        });

        if (areaPreferenceText.trim()) {
          const areaPreferenceType = preferences.find(
            (p) => p.id === 8 || p.preferenceName === "Area Preference"
          );

          if (areaPreferenceType) {
            collectedPreferences.push({
              id: preferenceIdCounter++,
              typeId: areaPreferenceType.id,
              typeLabel: areaPreferenceType.preferenceName,
              valueId: parseInt(areaPreferenceText.trim()), // Use 0 or a special value for text-based preferences
              valueLabel: areaPreferenceText.trim(),
              specialNote: "",
            });
          }
        }

        setAddedPreferences(collectedPreferences);
        setActiveTab("otherDetails");
        break;
      }
      case "otherDetails":
        setActiveTab("followup");
        break;
    }
  };

  // Submit handler
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setIsLoading(true);

      const tenantId = localStorage.getItem("tenantId");
      const currentUserId = localStorage.getItem("UserId");
      const isImpersonating =
        localStorage.getItem("isImpersonating") === "true";
      const originalSessionRaw =
        localStorage.getItem("originalSession");

      if (!tenantId || !currentUserId) {
        throw new Error("User ID or Tenant ID not found in localStorage");
      }

      console.log("===== Create Lead Debug =====");
      console.log("Current UserId:", currentUserId);
      console.log("Is Impersonating:", isImpersonating);
      console.log("Original Session:", originalSessionRaw);

      // ✅ Determine createdBy safely
      let createdByUserId: number;

      if (isImpersonating && originalSessionRaw) {
        const original = JSON.parse(originalSessionRaw);
        createdByUserId = parseInt(original.UserId);
        console.log("🔥 Using ADMIN UserId for createdBy:", createdByUserId);
      } else {
        createdByUserId = parseInt(currentUserId);
        console.log("🔥 Using Current UserId for createdBy:", createdByUserId);
      }

      // Helper functions
      const toNullableNumber = (value: number): number | null =>
        value === 0 ? null : value;

      const toNullableString = (value: string): string | null =>
        value.trim() === "" ? null : value.trim();

      const toNullableDate = (value?: string): string | null =>
        value && value.trim() !== "" ? value : null;

      // Preferences
      const preferences = addedPreferences.map((item) => ({
        preferenceTypeID: item.typeId,
        preferenceValue: item.valueId.toString(),
        specialNotes: item.specialNote || "",
      }));

      const initialAssignedUser =
        formData.initialAssignedUser === 0
          ? parseInt(currentUserId)
          : formData.initialAssignedUser;

      const currentAssignedUser =
        formData.currentAssignedUser === 0
          ? parseInt(currentUserId)
          : formData.currentAssignedUser;
      // Followups
      const followups = [];
      if (
        formData.scheduleFollowup &&
        formData.followupDate &&
        formData.followupType
      ) {
        followups.push({
          logId: null,
          projectId: toNullableNumber(formData.followupProject || 0),
          assignedUser: currentAssignedUser,
          followupTypeId: formData.followupType,
          followupDate: formData.followupDate,
          taskNotes: formData.followupRemarks || "",
        });
      }

      // Site Visits
      const siteVisits = [];
      if (formData.siteVisitProject && formData.siteVisitDateTime) {
        siteVisits.push({
          siteVisitDate: formData.siteVisitDateTime,
          projectId: formData.siteVisitProject,
          remark: formData.siteVisitRemarks || "",
        });
      }

      // Final Payload
      const payload = {
        firstName: formData.firstName.trim(),
        lastName: toNullableString(formData.lastName) || "",
        gender: toNullableString(formData.gender) || "",
        dob: toNullableDate(formData.dob),
        dom: toNullableDate(formData.dom),
        mobile: toNullableString(formData.mobile) || "",
        email: toNullableString(formData.email) || "",
        address: toNullableString(formData.address) || "",
        stateId: toNullableNumber(formData.stateId),
        districtId: toNullableNumber(formData.districtId),
        cityId: toNullableNumber(formData.cityId),
        zipCode: toNullableNumber(formData.zipCode),
        sourceId: toNullableNumber(formData.sourceId),
        subSourceId: toNullableNumber(formData.subSourceId),
        currentStatus: toNullableNumber(formData.currentStatus) || 1,
        incomeFrom: toNullableNumber(formData.incomeFrom),
        incomeTo: toNullableNumber(formData.incomeTo),
        budgetMin: toNullableNumber(formData.budgetMin),
        budgetMax: toNullableNumber(formData.budgetMax),
        initialAssignedUser,
        currentAssignedUser,
        tenantId: parseInt(tenantId),
        createdBy: createdByUserId, // ✅ FIXED HERE
        preferences,
        followups,
        siteVisits,
        countryCode: formData.countryCode,
        alternateMobile: toNullableString(formData.alternateMobile),
        alternateMobileCountryCode: formData.alternateMobileCountryCode,
      };

      console.log("📦 Payload to create lead:", payload);

      const createResponse = await createLead(payload);
      console.log("📨 API Response:", createResponse);

      if (createResponse.isCreated === true) {
        //toast.success("Lead created successfully");
        onSubmit();
        resetForm();
        onClose();
      } else {
        toast.error(createResponse.message);
      }
    } catch (err) {
      console.error("💥 Error creating lead:", err);
      toast.error("An error occurred while creating the lead");
    } finally {
      setIsLoading(false);
    }
  };


  const resetForm = () => {
    setFormData({
      firstName: "",
      lastName: "",
      gender: "",
      dob: "",
      dom: "",
      mobile: "",
      email: "",
      address: "",
      stateId: 0,
      districtId: 0,
      cityId: 0,
      zipCode: 0,
      sourceId: 0,
      subSourceId: 0,
      currentStatus: 0,
      incomeFrom: 0,
      incomeTo: 0,
      budgetMin: 0,
      budgetMax: 0,
      possession: "",
      initialAssignedUser: 0,
      currentAssignedUser: 0,
      tenantId: 0,
      createdBy: 0,
      assignType: "self",
      scheduleFollowup: false,
      countryCode: "+91",                 // ✅
      alternateMobile: "",
      alternateMobileCountryCode: "+91",  // ✅
    });
    setSelectedAssignUserId(null);
    setError({});
    setActiveTab("leadDetails");
    setAddedPreferences([]);
    setSelectedPreferenceId(null);
    setSelectedSecondary([]);
    setAreaPreferenceText("");
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  // Helper functions for select values
  const getSelectedOption = (options: any[], value: number) => {
    return options.find((option) => option.value === value) || null;
  };

  const getSelectedPreferenceOptions = (preferenceId: number): OptionType[] => {
    const selectedIds = selectedPreferences[preferenceId] || [];

    return (
      preferenceOptions[preferenceId]
        ?.filter((option: PreferenceOption) => selectedIds.includes(option.id))
        .map((option: PreferenceOption) => ({
          value: option.id,
          label: option.label,
        })) || []
    );
  };

  // Handler for multi-select change
  const handleMultiPreferenceChange = (
    preferenceId: number,
    selectedOptions: MultiValue<OptionType>
  ) => {
    const selectedIds = selectedOptions
      ? selectedOptions.map((option: OptionType) => option.value)
      : [];

    setSelectedPreferences((prev) => ({
      ...prev,
      [preferenceId]: selectedIds,
    }));
  };

  {/* Add this helper above the return statement — once, shared by both */ }
  const countryCodeOptions = countryCodes.map((cc) => ({
    value: cc.value,
    label: cc.fullLabel,
  }));

  const filterCountryCode = (option: any, inputValue: string) => {
    const search = inputValue.toLowerCase();
    return (
      option.label.toLowerCase().includes(search) ||
      option.value.toLowerCase().includes(search)
    );
  };

  // Shared styles object — reuse for both selects
  const countrySelectStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: "42px",
      height: "42px",
      fontSize: "13px",
      cursor: "pointer",
    }),
    valueContainer: (base: any) => ({
      ...base,
      padding: "0 6px",
    }),
    input: (base: any) => ({
      ...base,
      fontSize: "13px",
      margin: 0,
      padding: 0,
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base: any) => ({
      ...base,
      padding: "0 4px",
    }),
    menu: (base: any) => ({
      ...base,
      width: "200px",
      zIndex: 9999,
    }),
    menuList: (base: any) => ({
      ...base,
      maxHeight: "200px",
    }),
    option: (base: any, state: any) => ({
      ...base,
      fontSize: "13px",
      padding: "8px 12px",
      backgroundColor: state.isSelected
        ? "#9b2c6e"
        : state.isFocused
          ? "#f5ebf0"
          : "white",
      color: state.isSelected ? "white" : "#333",
    }),
    noOptionsMessage: (base: any) => ({
      ...base,
      fontSize: "13px",
    }),
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className={`modal-backdrop-custom ${isOpen ? "open" : "closed"}`}
        onClick={handleClose}
      ></div>
      <div className={`modal-custom ${isOpen ? "open" : "closed"}`}>
        <div className="modal-content" style={{ minWidth: "40rem" }}>
          <div className="modal-header-custom">
            <h5 className="modal-title-custom">Add Lead</h5>
            <button
              type="button"
              className="btn-close-custom"
              onClick={handleClose}
            >
              <span className="icon-close"></span>
            </button>
          </div>

          {/* Tab Navigation */}
          <ul
            className="nav nav-tabs pop-up-tabHeader"
            style={{ borderBottom: "1px solid rgb(245, 235, 240)" }}
          >
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link card-title tab-btn pop-up-tabHeaderbtn ${activeTab === "leadDetails" ? "active" : ""
                  }`}
                onClick={() => handleTabClick("leadDetails")}
                type="button"
              >
                Lead Details
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link card-title tab-btn pop-up-tabHeaderbtn ${activeTab === "preferences" ? "active" : ""
                  }`}
                onClick={() => handleTabClick("preferences")}
                type="button"
              >
                Lead Preference
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link card-title tab-btn pop-up-tabHeaderbtn ${activeTab === "otherDetails" ? "active" : ""
                  }`}
                onClick={() => handleTabClick("otherDetails")}
                type="button"
              >
                Other Details
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link card-title tab-btn pop-up-tabHeaderbtn ${activeTab === "followup" ? "active" : ""
                  }`}
                onClick={() => handleTabClick("followup")}
                type="button"
              >
                Follow-up
              </button>
            </li>
          </ul>

          <div className="modal-body-custom">
            <div className="card pop-up-card">
              <div className="tab-content card-body p-0" id="myTabContent">
                {/* Tab 1: Lead Details */}
                <div
                  className={`tab-pane fade ${activeTab === "leadDetails" ? "show active" : ""
                    }`}
                >
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="firstName" className="form-label">
                          First Name{requiredField}
                        </label>
                        <div className="input-with-icon">
                          <span className="input-icon icon-user"></span>
                          <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            placeholder="Enter First Name"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            className={`form-control-custom ${error.firstName ? "is-invalid" : ""
                              }`}
                          />
                          {error.firstName && (
                            <div className="invalid-feedback text-danger">
                              {error.firstName}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="lastName" className="form-label">
                          Last Name
                        </label>
                        <div className="input-with-icon">
                          <span className="input-icon icon-user"></span>
                          <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            placeholder="Enter Last Name"
                            value={formData.lastName}
                            onChange={handleInputChange}
                            className="form-control-custom"
                          />
                          {/* {error.lastName && (
                            <div className="invalid-feedback text-danger">
                              {error.lastName}
                            </div>
                          )} */}
                        </div>
                      </div>
                      {/* Mobile */}
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label className="form-label">Mobile{requiredField}</label>

                        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>

                          {/* Country Code */}
                          <div style={{ width: "85px", flexShrink: 0 }}>
                            <Select
                              options={countryCodeOptions}
                              value={{ value: formData.countryCode, label: formData.countryCode }}
                              onChange={(option) =>
                                setFormData({ ...formData, countryCode: option ? option.value : "+91" })
                              }
                              className="basic-single-select"
                              classNamePrefix="select"
                              isSearchable={true}               // ✅ search enabled
                              isClearable={false}
                              filterOption={filterCountryCode}  // ✅ search by code OR country name
                              placeholder="+91"
                              styles={countrySelectStyles}
                            />
                          </div>

                          {/* Mobile Input */}
                          <div className="input-with-icon flex-grow-1">
                            <span className="input-icon icon-phone"></span>
                            <input
                              type="text"
                              name="mobile"
                              placeholder="Enter Mobile No"
                              value={formData.mobile}
                              maxLength={15}
                              minLength={3}
                              onChange={handleInputChange}
                              className={`form-control-custom ${error.mobile ? "is-invalid" : ""}`}
                            />
                          </div>

                        </div>

                        {error.mobile && (
                          <div className="text-danger d-block" style={{ fontSize: "12px", marginTop: "4px" }}>
                            {error.mobile}
                          </div>
                        )}
                      </div>

                      {/* Alternate Mobile */}
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label className="form-label">Alternate Mobile</label>

                        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>

                          {/* Alternate Country Code */}
                          <div style={{ width: "85px", flexShrink: 0 }}>
                            <Select
                              options={countryCodeOptions}
                              value={
                                formData.alternateMobileCountryCode
                                  ? { value: formData.alternateMobileCountryCode, label: formData.alternateMobileCountryCode }
                                  : null
                              }
                              onChange={(option) =>
                                setFormData({ ...formData, alternateMobileCountryCode: option ? option.value : "+91" })
                              }
                              className="basic-single-select"
                              classNamePrefix="select"
                              isSearchable={true}               // ✅ search enabled
                              isClearable={false}
                              filterOption={filterCountryCode}  // ✅ search by code OR country name
                              placeholder="+91"
                              styles={countrySelectStyles}
                            />
                          </div>

                          {/* Alternate Mobile Input */}
                          <div className="input-with-icon flex-grow-1">
                            <span className="input-icon icon-phone"></span>
                            <input
                              type="text"
                              name="alternateMobile"
                              placeholder="Enter Alternate Mobile No"
                              value={formData.alternateMobile}
                              maxLength={15}
                              minLength={3}
                              onChange={handleInputChange}
                              className={`form-control-custom ${error.alternateMobile ? "is-invalid" : ""}`}
                            />
                          </div>

                        </div>

                        {error.alternateMobile && (
                          <div className="text-danger d-block" style={{ fontSize: "12px", marginTop: "4px" }}>
                            {error.alternateMobile}
                          </div>
                        )}
                      </div>


                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="email" className="form-label">
                          Email
                        </label>
                        <div className="input-with-icon">
                          <span className="input-icon icon-email"></span>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            className="form-control-custom"
                            placeholder="Enter Email"
                            value={formData.email}
                            onChange={handleInputChange}
                          />
                          {/* {error.email && (
                            <div className="invalid-feedback text-danger">
                              {error.email}
                            </div>
                          )} */}
                        </div>
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="sourceId" className="form-label">
                          Source{requiredField}
                        </label>
                        {isLoadingSourceMedia ? (
                          <div className="text-muted">Loading source...</div>
                        ) : (
                          <Select
                            options={mediaSourceOptions}
                            value={getSelectedOption(
                              mediaSourceOptions,
                              formData.sourceId
                            )}
                            onChange={(option) =>
                              handleSelectChange("sourceId", option)
                            }
                            className={`basic-single-select ${error.sourceId ? "is-invalid" : ""
                              }`}
                            classNamePrefix="select"
                            placeholder="Select Source"
                            isSearchable
                            isClearable
                          />
                        )}
                        {error.sourceId && (
                          <div className="invalid-feedback text-danger">
                            {error.sourceId}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="subSourceId" className="form-label">
                          Sub Source
                        </label>
                        <select
                          id="subSourceId"
                          name="subSourceId"
                          className={`form-select form-control-lg ${error.subSourceId ? "is-invalid" : ""
                            }`}
                          value={formData.subSourceId}
                          onChange={handleInputChange}
                        >
                          <option value="">
                            {formData.sourceId
                              ? filteredSubMediaSource.length > 0
                                ? "Select Sub Source"
                                : "No sub source available"
                              : "Select source first"}
                          </option>
                          {filteredSubMediaSource.map((ssrc) => (
                            <option key={ssrc.id} value={ssrc.id}>
                              {ssrc.name}
                            </option>
                          ))}
                        </select>
                        {error.subSourceId && (
                          <div className="invalid-feedback text-danger">
                            {error.subSourceId}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-lg-12 mb-3 input-group-custom">
                        <label className="form-label d-block mb-2">
                          Assign Type{requiredField}
                        </label>

                        {/* Show "Assign" option only if userTypeId !== 4 */}
                        {parseInt(localStorage.getItem("userTypeId") ?? "0") !== 4 && (
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              id="assign"
                              name="assignType"
                              value="assign"
                              checked={formData.assignType === "assign"}
                              onChange={handleInputChange}
                            />
                            <label className="form-check-label" htmlFor="assign">
                              Assign
                            </label>
                          </div>
                        )}

                        {/* Always show "Self" option */}
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="self"
                            name="assignType"
                            value="self"
                            checked={formData.assignType === "self"}
                            onChange={handleInputChange}
                          />
                          <label className="form-check-label" htmlFor="self">
                            Self
                          </label>
                        </div>

                        {error.assignType && (
                          <div className="invalid-feedback text-danger d-block">
                            {error.assignType}
                          </div>
                        )}
                      </div>


                      {formData.assignType === "assign" && (
                        <div className="col-12 col-lg-12 mb-3 input-group-custom">
                          <label
                            htmlFor="initialAssignedUser"
                            className="form-label"
                          >
                            Assign to User{requiredField}
                          </label>
                          <select
                            id="initialAssignedUser"
                            name="initialAssignedUser"
                            className={`form-select form-control-lg ${error.initialAssignedUser ? "is-invalid" : ""
                              }`}
                            value={formData.initialAssignedUser}
                            onChange={handleInputChange}
                          >
                            <option value="">Select User</option>
                            {assignedUser.map((usr) => (
                              <option key={usr.userId} value={usr.userId}>
                                {usr.userName}
                              </option>
                            ))}
                          </select>
                          {error.initialAssignedUser && (
                            <div className="invalid-feedback text-danger">
                              {error.initialAssignedUser}
                            </div>
                          )}
                        </div>
                      )}
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    </div>
                  </form>
                </div>

                {/* Tab 2: Lead Preference */}
                <div
                  className={`tab-pane fade ${activeTab === "preferences" ? "show active" : ""
                    }`}
                >
                  <div className="row">
                    <div className="col-12 mb-3">
                      <h6 className="text-primary fw-bolder">
                        Select Your Preferences
                      </h6>
                      <small className="text-muted">
                        Choose values for the preference types that are relevant
                        to you
                      </small>
                    </div>

                    {preferences.map((preference) => {
                      // Only show preferences that have options available
                      // if (
                      //   !preferenceOptions[preference.id] ||
                      //   preferenceOptions[preference.id].length === 0
                      // ) {
                      //   return null;
                      // }

                      if (
                        preference.id === 8 ||
                        preference.preferenceName === "Area Preference"
                      ) {
                        return (
                          <div
                            key={preference.id}
                            className="col-12 col-lg-12 mb-3 input-group-custom"
                          >
                            <label
                              className="form-label"
                              htmlFor={`preference-${preference.id}`}
                            >
                              {preference.preferenceName}
                            </label>
                            <input
                              type="text"
                              id={`preference-${preference.id}`}
                              name="areaPreference"
                              className="form-control-custom"
                              placeholder={`Enter ${preference.preferenceName}`}
                              value={areaPreferenceText}
                              onChange={(e) =>
                                setAreaPreferenceText(e.target.value)
                              }
                              disabled={isLoading}
                            />
                            <small className="text-muted">
                              Enter area preference details (e.g., Sqft.)
                            </small>
                          </div>
                        );
                      } else {
                        return (
                          <div
                            key={preference.id}
                            className="col-12 col-lg-12 mb-3 input-group-custom"
                          >
                            <label
                              className="form-label"
                              htmlFor={`preference-${preference.id}`}
                            >
                              {preference.preferenceName}
                            </label>
                            <Select
                              options={
                                preferenceOptions[preference.id]?.map(
                                  (option) => ({
                                    value: option.id,
                                    label: option.label,
                                  })
                                ) || []
                              }
                              value={getSelectedPreferenceOptions(
                                preference.id
                              )}
                              onChange={(selectedOptions) =>
                                handleMultiPreferenceChange(
                                  preference.id,
                                  selectedOptions
                                )
                              }
                              className={`basic-multi-select`}
                              classNamePrefix="select"
                              placeholder={`Select ${preference.preferenceName}`}
                              isSearchable
                              isClearable
                              isMulti // This enables multi-select
                              isDisabled={isLoading}
                            />
                          </div>
                        );
                      }
                    })}

                    {/* Add spacing divs */}
                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                  </div>
                </div>

                {/* Tab 3: Other Details */}
                <div
                  className={`tab-pane fade ${activeTab === "otherDetails" ? "show active" : ""
                    }`}
                >
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="budgetMin" className="form-label">
                          Budget Min
                        </label>
                        <div className="input-with-icon">
                          <span className="input-icon icon-rupee"></span>
                          <input
                            type="text"
                            id="budgetMin"
                            name="budgetMin"
                            className="form-control-custom"
                            placeholder="Enter Minimum Budget"
                            value={
                              formData.budgetMin === 0 ? "" : formData.budgetMin
                            }
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="budgetMax" className="form-label">
                          Budget Max
                        </label>
                        <div className="input-with-icon">
                          <span className="input-icon icon-rupee"></span>
                          <input
                            type="text"
                            id="budgetMax"
                            name="budgetMax"
                            className="form-control-custom"
                            placeholder="Enter Maximum Budget"
                            value={
                              formData.budgetMax === 0 ? "" : formData.budgetMax
                            }
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="incomeFrom" className="form-label">
                          Income Min
                        </label>
                        <div className="input-with-icon">
                          <span className="input-icon icon-rupee"></span>
                          <input
                            type="text"
                            id="incomeFrom"
                            name="incomeFrom"
                            className="form-control-custom"
                            placeholder="Enter Minimum Income"
                            value={
                              formData.incomeFrom === 0
                                ? ""
                                : formData.incomeFrom
                            }
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="incomeTo" className="form-label">
                          Income Max
                        </label>
                        <div className="input-with-icon">
                          <span className="input-icon icon-rupee"></span>
                          <input
                            type="text"
                            id="incomeTo"
                            name="incomeTo"
                            className="form-control-custom"
                            placeholder="Enter Maximum Income"
                            value={
                              formData.incomeTo === 0 ? "" : formData.incomeTo
                            }
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-lg-12 mb-3 input-group-custom">
                        <label htmlFor="address" className="form-label">
                          Address
                        </label>
                        <textarea
                          id="address"
                          name="address"
                          placeholder="Enter Address"
                          value={formData.address}
                          onChange={handleInputChange}
                          className={`form-control-custom-textarea ${error.address ? "is-invalid" : ""
                            }`}
                        />
                        {error.address && (
                          <div className="invalid-feedback text-danger">
                            {error.address}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="zipCode" className="form-label">
                          Zipcode
                        </label>
                        <input
                          type="text"
                          id="zipCode"
                          name="zipCode"
                          maxLength={6}
                          className={`form-control-custom1 form-control-custom-lg ${error.zipCode ? "is-invalid" : ""
                            }`}
                          placeholder="Enter Zipcode"
                          value={formData.zipCode === 0 ? "" : formData.zipCode}
                          onChange={handleInputChange}
                        />
                        {error.zipCode && (
                          <div className="invalid-feedback text-danger">
                            {error.zipCode}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label className="form-label" htmlFor="gender">
                          Gender
                        </label>
                        <select
                          id="gender"
                          name="gender"
                          value={formData.gender}
                          onChange={handleInputChange}
                          className={`form-select form-control-lg ${error.gender ? "is-invalid" : ""
                            }`}
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                        {error.gender && (
                          <div className="invalid-feedback text-danger">
                            {error.gender}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label className="form-label" htmlFor="possession">
                          Possession
                        </label>
                        <select
                          id="possession"
                          name="possession"
                          value={formData.possession}
                          onChange={handleInputChange}
                          className="form-select form-control-lg"
                        >
                          <option value="">Select Possession</option>
                          <option value="Immediate">Immediate</option>
                          <option value="Within 3 months">
                            Within 3 months
                          </option>
                          <option value="Within 6 months">
                            Within 6 months
                          </option>
                          <option value="Within 1 year">Within 1 year</option>
                          <option value="More than 1 year">
                            More than 1 year
                          </option>
                        </select>
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="stateId" className="form-label">
                          State
                        </label>
                        <Select
                          options={stateOptions}
                          value={getSelectedOption(
                            stateOptions,
                            formData.stateId
                          )}
                          onChange={(option) =>
                            handleSelectChange("stateId", option)
                          }
                          className={`basic-single-select ${error.stateId ? "is-invalid" : ""
                            }`}
                          classNamePrefix="select"
                          placeholder="Select State"
                          isSearchable
                          isClearable
                        />
                        {error.stateId && (
                          <div className="invalid-feedback text-danger">
                            {error.stateId}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="districtId" className="form-label">
                          District
                        </label>
                        <Select
                          options={districtOptions}
                          value={getSelectedOption(
                            districtOptions,
                            formData.districtId
                          )}
                          onChange={(option) =>
                            handleSelectChange("districtId", option)
                          }
                          className={`basic-single-select ${error.districtId ? "is-invalid" : ""
                            }`}
                          classNamePrefix="select"
                          placeholder={
                            formData.stateId
                              ? districtOptions.length > 0
                                ? "Select District"
                                : "No districts available"
                              : "Select state first"
                          }
                          isSearchable
                          isClearable
                          isDisabled={!formData.stateId}
                        />
                        {error.districtId && (
                          <div className="invalid-feedback text-danger">
                            {error.districtId}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="cityId" className="form-label">
                          City
                        </label>
                        <Select
                          options={cityOptions}
                          value={getSelectedOption(
                            cityOptions,
                            formData.cityId
                          )}
                          onChange={(option) =>
                            handleSelectChange("cityId", option)
                          }
                          className={`basic-single-select ${error.cityId ? "is-invalid" : ""
                            }`}
                          classNamePrefix="select"
                          placeholder={
                            formData.districtId
                              ? cityOptions.length > 0
                                ? "Select City"
                                : "No cities available"
                              : "Select district first"
                          }
                          isSearchable
                          isClearable
                          isDisabled={!formData.districtId}
                        />
                        {error.cityId && (
                          <div className="invalid-feedback text-danger">
                            {error.cityId}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label className="form-label" htmlFor="dob">
                          Date of Birth
                        </label>
                        <input
                          type="date"
                          id="dob"
                          name="dob"
                          value={formData.dob}
                          onChange={handleInputChange}
                          className="form-control-custom1 form-control-custom-lg"
                        />
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom">
                        <label htmlFor="dom" className="form-label">
                          Date of Marriage
                        </label>
                        <input
                          type="date"
                          id="dom"
                          name="dom"
                          value={formData.dom}
                          onChange={handleInputChange}
                          className="form-control-custom1 form-control-custom-lg"
                        />
                      </div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                      <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    </div>
                  </form>
                </div>

                {/* Tab 4: Follow-up */}
                <div
                  className={`tab-pane fade ${activeTab === "followup" ? "show active" : ""
                    }`}
                >
                  <div className="row">
                    <div className="col-12 mb-4">
                      <h6 className="text-primary fw-bolder">
                        Site Visit Details (Optional)
                      </h6>
                      <small className="text-muted">
                        Fill this section if the lead has visited a site before
                        lead entry
                      </small>
                    </div>

                    <div className="col-12 col-lg-6 mb-3 input-group-custom">
                      <label htmlFor="siteVisitProject" className="form-label">
                        Project
                      </label>
                      <Select
                        options={projectOptions}
                        value={getSelectedOption(
                          projectOptions,
                          formData.siteVisitProject || 0
                        )}
                        onChange={(option) =>
                          handleSelectChange("siteVisitProject", option)
                        }
                        className="basic-single-select"
                        classNamePrefix="select"
                        placeholder="Select Project"
                        isSearchable
                        isClearable
                        isLoading={isLoadingProjects}
                      />
                    </div>

                    <div className="col-12 col-lg-6 mb-3 input-group-custom">
                      <label htmlFor="siteVisitDateTime" className="form-label">
                        Site Visit Date & Time
                        {formData.siteVisitProject === 0
                          ? ""
                          : formData.siteVisitProject
                            ? requiredField
                            : ""}
                      </label>

                      <input
                        type="datetime-local"
                        id="siteVisitDateTime"
                        name="siteVisitDateTime"
                        value={formData.siteVisitDateTime || ""}
                        max={new Date().toISOString().slice(0, 16)}   // ❗ Prevent future date
                        onChange={handleInputChange}
                        className={`form-control-custom1 form-control-custom-lg ${error.siteVisitDateTime ? "is-invalid" : ""
                          }`}
                      />

                      {error.siteVisitDateTime && (
                        <div className="invalid-feedback text-danger">
                          {error.siteVisitDateTime}
                        </div>
                      )}
                    </div>

                    <div className="col-12 mb-3 input-group-custom">
                      <label htmlFor="siteVisitRemarks" className="form-label">
                        Site Visit Remarks
                      </label>
                      <textarea
                        id="siteVisitRemarks"
                        name="siteVisitRemarks"
                        placeholder="Enter site visit remarks"
                        value={formData.siteVisitRemarks || ""}
                        onChange={handleInputChange}
                        className="form-control-custom-textarea"
                        rows={3}
                      />
                    </div>

                    <div className="col-12 mb-4">
                      <hr />
                      <h6 className="text-primary fw-bolder">
                        Schedule Follow-up (Optional)
                      </h6>
                    </div>

                    <div className="col-12 mb-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="scheduleFollowup"
                          name="scheduleFollowup"
                          checked={formData.scheduleFollowup}
                          onChange={handleInputChange}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="scheduleFollowup"
                        >
                          Schedule a follow-up
                        </label>
                      </div>
                    </div>

                    {formData.scheduleFollowup && (
                      <>
                        <div className="col-12 col-lg-6 mb-3 input-group-custom">
                          <label htmlFor="followupDate" className="form-label">
                            Follow-up Date & Time{requiredField}
                          </label>
                          <input
                            type="datetime-local"
                            id="followupDate"
                            name="followupDate"
                            value={formData.followupDate || ""}
                            onChange={handleDateTimeChange}
                            min={new Date().toISOString().slice(0, 16)}
                            className={`form-control-custom1 form-control-custom-lg ${error.followupDate ? "is-invalid" : ""
                              }`}
                          />
                          {error.followupDate && (
                            <div className="invalid-feedback text-danger">
                              {error.followupDate}
                            </div>
                          )}
                        </div>

                        <div className="col-12 col-lg-6 mb-3 input-group-custom">
                          <label htmlFor="followupType" className="form-label">
                            Follow-up Type{requiredField}
                          </label>
                          <Select
                            options={followupTypeOptions}
                            value={getSelectedOption(
                              followupTypeOptions,
                              formData.followupType || 0
                            )}
                            onChange={(option) =>
                              handleSelectChange("followupType", option)
                            }
                            className={`basic-single-select ${error.followupType ? "is-invalid" : ""
                              }`}
                            classNamePrefix="select"
                            placeholder="Select Follow-up Type"
                            isSearchable
                            isClearable
                            isLoading={isLoadingFollowupTypes}
                          />
                          {error.followupType && (
                            <div className="invalid-feedback text-danger">
                              {error.followupType}
                            </div>
                          )}
                        </div>

                        <div className="col-12 col-lg-12 mb-3 input-group-custom">
                          <label
                            htmlFor="followupProject"
                            className="form-label"
                          >
                            Project
                          </label>
                          <Select
                            options={projectOptions}
                            value={getSelectedOption(
                              projectOptions,
                              formData.followupProject || 0
                            )}
                            onChange={(option) =>
                              handleSelectChange("followupProject", option)
                            }
                            className={`basic-single-select ${error.followupProject ? "is-invalid" : ""
                              }`}
                            classNamePrefix="select"
                            placeholder="Select Project"
                            isSearchable
                            isClearable
                            isLoading={isLoadingProjects}
                          />
                          {error.followupProject && (
                            <div className="invalid-feedback text-danger">
                              {error.followupProject}
                            </div>
                          )}
                        </div>

                        <div className="col-12 mb-3 input-group-custom">
                          <label
                            htmlFor="followupRemarks"
                            className="form-label"
                          >
                            Follow-up Remarks{requiredField}
                          </label>
                          <textarea
                            id="followupRemarks"
                            name="followupRemarks"
                            placeholder="Enter follow-up remarks"
                            value={formData.followupRemarks || ""}
                            onChange={handleInputChange}
                            className="form-control-custom-textarea"
                            rows={3}
                          />
                        </div>
                      </>
                    )}

                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                    <div className="col-12 col-lg-6 mb-3 input-group-custom"></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer-custom">
              <div>
                {activeTab === "leadDetails" && (
                  <>
                    <button
                      type="button"
                      className="btn-custom btn-cancel"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn-custom btn-primary-custom"
                      onClick={() => handleNext("leadDetails")}
                    >
                      Next
                    </button>
                  </>
                )}

                {activeTab === "preferences" && (
                  <>
                    <button
                      type="button"
                      className="btn-custom btn-secondary"
                      onClick={() => setActiveTab("leadDetails")}
                    >
                      Previous
                    </button>
                    <button
                      type="button"
                      className="btn-custom btn-cancel"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn-custom btn-primary-custom"
                      onClick={() => handleNext("preferences")}
                    >
                      Next
                    </button>
                  </>
                )}

                {activeTab === "otherDetails" && (
                  <>
                    <button
                      type="button"
                      className="btn-custom btn-secondary"
                      onClick={() => setActiveTab("preferences")}
                    >
                      Previous
                    </button>
                    <button
                      type="button"
                      className="btn-custom btn-cancel"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn-custom btn-primary-custom"
                      onClick={() => handleNext("otherDetails")}
                    >
                      Next
                    </button>
                  </>
                )}

                {activeTab === "followup" && (
                  <>
                    <button
                      type="button"
                      className="btn-custom btn-secondary"
                      onClick={() => setActiveTab("otherDetails")}
                    >
                      Previous
                    </button>
                    <button
                      type="button"
                      className="btn-custom btn-cancel"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn-custom btn-primary-custom"
                      onClick={handleSubmit}
                      disabled={isLoading}
                    >
                      {isLoading ? "Creating Lead..." : "Create Lead"}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <OverlayLoader
          loading={isLoadingSourceMedia}
          message="Loading Lead Data"
          submessage="This might take a moment..."
        />
      </div>
    </>
  );
};

export default AddLeadModal;
